import React from 'react';
import {Maybe} from 'monet';
import {useTranslation} from 'react-i18next';
import download from '@/assets/images/download.png';
import DownloadFileButton from '@/views/shared/DownloadFileButton';
import styles from '@/b2c/PlanDetail/index.module.css';

const ProviderStatement = ({providerShortName, providerStatementPath}) => {
  const {t: tr} = useTranslation('statements');

  const Content = () => (
    <div className='text-left'>
      <span className={styles.text_vendor}>
        {tr('provider_statement')} {providerShortName}
      </span>
      <DownloadFileButton className='btn btn-link' path={providerStatementPath}>
        <img alt='Download' src={download} />
      </DownloadFileButton>
    </div>
  );

  return Maybe.fromFalsy(providerStatementPath)
    .map(() => <Content />)
    .orNull();
};

export default ProviderStatement;
